module.exports = __webpack_public_path__ + "img/course72_summary_unit_timelines.540f4741.jpg";